import { useState } from 'react';

import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';

import { Button } from '@lemoment/ui-kit';

import { LeaveFormDialog } from '../../leaves';
import {
  TeamCalendar,
  TeamEventFormDialog,
  TodayAwayList,
  TodayEventList,
} from '../components';

const stagger = { animate: { transition: { staggerChildren: 0.07 } } };
const fadeUp = {
  initial: { opacity: 0, y: 14 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { type: 'spring' as const, stiffness: 280, damping: 28 },
  },
};

const now = new Date();
const HERO_DATE = new Intl.DateTimeFormat('ko-KR', {
  month: 'long',
  day: 'numeric',
  weekday: 'long',
}).format(now);

export const TeamHomePage = () => {
  const [open, setOpen] = useState(false);
  const [eventOpen, setEventOpen] = useState(false);

  return (
    <motion.div
      className="mx-auto flex w-full max-w-xl flex-col gap-6 px-5 pb-32 pt-20 md:pt-12 lg:max-w-4xl"
      variants={stagger}
      initial="initial"
      animate="animate"
    >
      <motion.header
        variants={fadeUp}
        className="relative flex items-end justify-between"
      >
        <div className="relative z-10">
          <p className="eyebrow text-lemon-ink dark:text-lemon">오늘</p>
          <h1 className="font-display mt-1.5 text-balance text-[2.6rem] font-bold leading-[1.05] tracking-tight">
            {HERO_DATE}
          </h1>
        </div>
        <span
          className="font-numeral pointer-events-none absolute right-0 top-1/2 -translate-y-1/2 text-7xl font-bold leading-none text-primary/15"
          aria-hidden
        >
          {now.getDate()}
        </span>
      </motion.header>

      <motion.div
        variants={fadeUp}
        className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_20rem] lg:items-start"
      >
        <div className="order-2 lg:order-1">
          <TeamCalendar />
        </div>
        <div className="order-1 flex flex-col gap-6 lg:order-2">
          <TodayAwayList />
          <TodayEventList onAdd={() => setEventOpen(true)} />
        </div>
      </motion.div>

      <Button
        size="icon"
        onClick={() => setOpen(true)}
        aria-label="근태 등록"
        className="animate-lemon-glow fixed bottom-24 right-5 z-10 h-14 w-14 rounded-full bg-lemon text-lemon-foreground shadow-lg shadow-primary/30 transition-transform hover:bg-lemon/90 active:scale-90 md:bottom-8"
      >
        <Plus className="h-6 w-6" strokeWidth={2.4} />
      </Button>

      <LeaveFormDialog open={open} onOpenChange={setOpen} />
      <TeamEventFormDialog open={eventOpen} onOpenChange={setEventOpen} />
    </motion.div>
  );
};
